import axios from '../axios'
import qs from 'qs';
import { getToken } from '@/utils/auth';

//查询成就
export const query = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/achievement/query.php',
		method:'post',
		data
	})
}

//分享成就
export const share = ()=>{
	let data = {
		token:getToken(),
	};
	data = qs.stringify(data);
	return axios({
		url:'/achievement/achi.share.web.php',
		method:'post',
		data
	});
}

//查询分享足迹
export const shareQuery = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/achievement/achi.share.web.query.php',
		method:'post',
		data
	});
}



// WEBPACK FOOTER //
// ./src/provider/api/achievement.js